"use client";

import { Navigation } from "@/components/ui/navigation";
import MagicBento from "@/components/MagicBento";
import { useMhiveTour } from "@/hooks/use-mhive-tour";

export const dynamic = "force-dynamic";

const colors = [
  "#f72585",
  "#8b5cf6",
  "#eb5e28",
  "#00b4d8",
];

const navItems = [
  {
    href: "/mcore",
    label: "mCore",
    symbol: "mC",
    iconSrc: "/icons/mc_icon.svg",
    description: "",
    color: colors[0] + "20",
    glowColor: colors[0],
  },
  {
    href: "/connection-studio",
    label: "Connection Studio",
    symbol: "cS",
    iconSrc: "/icons/cs_icon.svg",
    description: "",
    color: colors[1] + "20",
    glowColor: colors[1],
  },
  {
    href: "/campus-spaces",
    label: "Campus",
    symbol: "Ca",
    iconSrc: "/icons/ms_icon.svg",
    description: "",
    color: colors[3] + "20",
    glowColor: colors[3],
  },
  {
    href: "/hive-spaces",
    label: "mSpace",
    symbol: "mS",
    iconSrc: "/icons/mspace-logo.svg",
    description: "",
    color: colors[2] + "20",
    glowColor: colors[2],
  },
];

export default function Home() {
  useMhiveTour(); // Initialize tour hook

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#050810]">
      <Navigation />

      <div className="relative flex flex-1 items-center justify-center overflow-hidden bg-gradient-to-b from-[#0a0f1a] via-[#0d1526] to-[#050810]">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(139,92,246,0.15),_transparent_55%)]" />
        <div className="pointer-events-none absolute -top-40 right-1/4 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-40 left-1/4 h-72 w-72 rounded-full bg-fuchsia-500/15 blur-3xl" />

        <div className="magic-bento-container h-full w-full relative z-10">
          <MagicBento
            width="100vw"
            height="100%"
            navItems={navItems}
            textAutoHide={false}
            enableStars={true}
            enableSpotlight={true}
            enableBorderGlow={true}
            enableTilt={false}
            glowColor="139, 92, 246"
            clickEffect={true}
            enableMagnetism={false}
            spotlightRadius={300}
            particleCount={33}
          />
        </div>
      </div>

    </div>
  );
}
